import { useState, useCallback } from 'react';
import { ALL_REGION_VALUE } from '../../../constants/escalateQueryDialog';

/**
 * Custom hook for managing escalation query dialog state
 * @returns {Object} State and state setters
 */
export const useEscalateQueryState = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [region, setRegion] = useState(ALL_REGION_VALUE);
  const [targets, setTargets] = useState([]);
  const [allowedRoles, setAllowedRoles] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [loadError, setLoadError] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUserId, setSelectedUserId] = useState('');
  const [errors, setErrors] = useState({});

  const resetState = useCallback(() => {
    setRegion(ALL_REGION_VALUE);
    setSelectedRole('');
    setSelectedUserId('');
    setErrors({});
    setLoadError('');
  }, []);

  return {
    // State
    currentUser,
    region,
    targets,
    allowedRoles,
    loadingOptions,
    loadError,
    selectedRole,
    selectedUserId,
    errors,
    // Setters
    setCurrentUser,
    setRegion,
    setTargets,
    setAllowedRoles,
    setLoadingOptions,
    setLoadError,
    setSelectedRole,
    setSelectedUserId,
    setErrors,
    // Utilities
    resetState,
  };
};
